import { useEffect } from 'preact/hooks';
import 'i18next';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { DropdownIcon } from '../svg/DropdownIcon';
export var SelectNative = function (props) {
    var options = props.options, label = props.label, onSelect = props.onSelect, required = props.required, placeholder = props.placeholder;
    var _a = useState(), selected = _a[0], setSelected = _a[1];
    useEffect(function () {
        if (props.defaultSelected) {
            setSelected(props.defaultSelected);
        }
        else {
            setSelected(placeholder ? '' : options[0].value);
        }
    }, [props.defaultSelected]);
    var t = useTranslation().t;
    useEffect(function () {
        var options = props.options;
        if (!placeholder && Array.isArray(options) && options.length > 0) {
            onSelect(options[0].value);
        }
    }, []);
    return (React.createElement("div", { className: "flex w-full flex-col" },
        React.createElement("label", { className: "pb-2 text-semi-base font-bold", htmlFor: label },
            label,
            ' ',
            required && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "font-bold text-common-tomato" }, 
                // eslint-disable-next-line react/jsx-no-literals
                '*'),
                React.createElement("span", { className: "text-[12px] text-common-tomato" },
                    ' ',
                    t('common.formRequired', 'required'))))),
        React.createElement("div", { className: "relative mb-2.5 mr-3.75" },
            React.createElement("select", { name: label, id: label, value: selected, onChange: function (e) {
                    onSelect(e.target.value);
                    setSelected(e.target.value);
                }, className: twMerge('w-full cursor-pointer appearance-none rounded-md border border-solid border-ui-light-gray bg-white p-3 font-primary text-[14px] font-normal outline-none', selected === '' && 'text-common-smoke', 'focus:shadow-focus-outset') },
                placeholder && (React.createElement("option", { className: "top-1.25", value: "", disabled: true, hidden: true, selected: selected === '', "data-default": true }, placeholder)),
                options.map(function (option) { return (React.createElement("option", { value: option.value, selected: option.value === selected, "aria-label": option.label, key: option.value }, option.label)); })),
            React.createElement(DropdownIcon, { className: "absolute right-4 top-3.5" }))));
};
export default SelectNative;
